import React, { useEffect, useState } from "react";
import {
  Flex,
  Box,
  Button,
  Table,
  Tbody,
  Text,
  Th,
  Td,
  Thead,
  Tr,
  IconButton,
  useColorModeValue,
  Badge,
  Select,
  Input,
  useDisclosure,
} from "@chakra-ui/react";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import AccountApi from "api/account";
import Pagination from "components/Pagination/Pagination";
import { convertToJalali } from "utils/helper";
import EditAccountModal from "components/Modal/EditAccountModal";
import AccountExcelModal from "components/Modal/AccountExcelModal";
import { useHistory } from "react-router-dom";

function Accounts() {
  const [accounts, setAccounts] = useState([]);
  const [search, setSearch] = useState("");
  const [orderBy, setOrderBy] = useState("updated_at");
  const [orderDirection, setOrderDirection] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [currentAccount, setCurrentAccount] = useState(null);
  const textColor = useColorModeValue("gray.700", "white");
  const history = useHistory();

  const {
    isOpen: isEditModalOpen,
    onOpen: onEditModalOpen,
    onClose: onEditModalClose,
  } = useDisclosure();

  const {
    isOpen: isExcelModalOpen,
    onOpen: onExcelModalOpen,
    onClose: onExcelModalClose,
  } = useDisclosure();

  useEffect(() => {
    fetchAccounts(currentPage);
  }, [search, orderBy, orderDirection, currentPage]);

  const fetchAccounts = async (page = 1) => {
    try {
      const response = await AccountApi.Index({ search, orderBy, orderDirection, page });
      setAccounts(response.data.data);
      setTotalPages(response.data.meta.last_page);
    } catch (err) {
      console.error("Error fetching accounts:", err);
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const handleOrderByChange = (e) => {
    setOrderBy(e.target.value);
    setCurrentPage(1);
  };

  const handleOrderDirectionChange = (e) => {
    setOrderDirection(e.target.value);
    setCurrentPage(1);
  };

  const handleEdit = (account) => {
    setCurrentAccount(account);
    onEditModalOpen();
  };

  const handleDelete = (accountId) => {
    console.log("Delete account with id:", accountId);
  };

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <CardHeader p="6px 0px 22px 0px" display="flex" alignItems="center" justifyContent="space-between">
          <Text fontSize="xl" color={textColor} fontWeight="bold">
            جدول اکانت ها
          </Text>
          <Box display="flex" maxWidth="720px" alignItems="center" justifyContent="flex-end">
            <Button size="sm" minW="170px" colorScheme="blue" ml={3} onClick={onExcelModalOpen}>
              ساخت اکسل   
            </Button>
            <Button size="sm" minW="170px" colorScheme="purple" ml={3} onClick={() => history.push("/admin/accounts/shared")}>
              اکانت اشتراکی
            </Button>
            <Select textAlign="left" width="250px" value={orderBy} onChange={handleOrderByChange} ml={3}>
              <option value="email">نام</option>
              <option value="created_at">تاریخ ایجاد</option>
              <option value="updated_at">آخرین تغییر</option>
            </Select>
            <Select textAlign="left" width="200px" value={orderDirection} onChange={handleOrderDirectionChange} ml={3}>
              <option value="asc">صعودی</option>
              <option value="desc">نزولی</option>
            </Select>
            <Input placeholder="جستجو" value={search} onChange={handleSearchChange} ml={3} />
          </Box>
        </CardHeader>
        <CardBody>
          <Table variant="simple" color={textColor}>
            <Thead>
              <Tr my=".8rem" pl="0px" color="gray.400">
                <Th color="gray.400">آیدی</Th>
                <Th width="8%" pl="0px" color="gray.400">
                  ایمیل
                </Th>
                <Th width="20%" color="gray.400">
                  نام محصول
                </Th>
                <Th color="gray.400">تاریخ</Th>
                <Th width="8%" color="gray.400">
                  ریجن
                </Th>
                <Th width="5%" color="gray.400">
                  وضعیت
                </Th>
                <Th></Th>
              </Tr>
            </Thead>
            <Tbody>
              {accounts.map((account) => (
                <Tr key={account.id}>
                  <Td>{account.id}</Td>
                  <Td>{account.email}</Td>
                  <Td>{account.product_name}</Td>
                  <Td>{convertToJalali(account.created_at)}</Td>
                  <Td style={{ fontSize: "1.3em" }}>
                    {account.region === "us"
                      ? "🇺🇸"
                      : account.region === "tr"
                      ? "🇹🇷"
                      : account.region
                      ? account.region.toUpperCase()
                      : "-"}
                  </Td>
                  <Td>
                    {account.is_deactive ? (
                      <Badge colorScheme="green" variant="solid" fontSize="sm" p={2} borderRadius="md">
                        دی اکتیو
                      </Badge>
                    ) : (
                      <Badge colorScheme="red" variant="solid" fontSize="sm" p={2} borderRadius="md">
                        دی اکتیو نشده
                      </Badge>
                    )}
                  </Td>
                  <Td textAlign="center">
                    <Button size="sm" colorScheme="teal" bg="teal.500" color="white" mr={2} onClick={() => handleEdit(account)}>
                      ویرایش
                    </Button>
                    <IconButton
                      size="sm"
                      colorScheme="blue"
                      aria-label="Edit"
                      icon={<EditIcon />}
                      onClick={() => handleEdit(account)}
                      mr={1}
                    />
                    <IconButton
                      size="sm"
                      colorScheme="red"
                      aria-label="Delete"
                      icon={<DeleteIcon />}
                      onClick={() => handleDelete(account.id)}
                      mr={1}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </CardBody>
      </Card>
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
      {currentAccount && (
        <EditAccountModal
          isOpen={isEditModalOpen}
          onClose={onEditModalClose}
          accountId={currentAccount.id}
          productName={currentAccount.product_name}
        />
      )}
      <AccountExcelModal isOpen={isExcelModalOpen} onClose={onExcelModalClose} />
    </Flex>
  );
}

export default Accounts;
